import * as React from 'react';
import PropTypes from 'prop-types';

const CreditCard = ({ color, ...props }) => (
  <svg
    width={25}
    height={24}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect
      x={3.697}
      y={6.004}
      width={18.009}
      height={12.984}
      rx={2}
      stroke={color || '#549A9A'}
      strokeWidth={2}
    />
    <path
      d="M7.7 14.994h.01M4.697 10.998h17.009"
      stroke={color || '#549A9A'}
      strokeWidth={2}
      strokeLinecap="round"
    />
  </svg>
);

export default CreditCard;

CreditCard.propTypes = {
  color: PropTypes.string.isRequired,
};
